export default abstract class AbstractUser {
    private readonly _id: string;
    private readonly _firstName: string;
    private readonly _infix: string|null;
    private readonly _lastName: string;
    private readonly _links: object;

    constructor({
        id,
        name,
        firstName,
        infix,
        lastName,
        links,
    }) {
        this._id = id;

        if (name && typeof name === 'object') {
            firstName = name.first || firstName;
            lastName = name.last || lastName;
            infix = name.infix || infix;
        }

        this._firstName = firstName;
        this._infix = infix ? infix : null;
        this._lastName = lastName;
        this._links = links;
    }

    get id(): string {
        return this._id;
    }

    get firstName(): string {
        return this._firstName;
    }

    get infix(): string | null {
        return this._infix;
    }

    get lastName(): string {
        return this._lastName;
    }

    public get name() {
        if (this._infix !== null) {
            return `${this._firstName} ${this._infix} ${this._lastName}`;
        }

        return `${this._firstName} ${this._lastName}`;
    }

    get links(): object {
        return this._links;
    }
}
